module.exports = __webpack_public_path__ + "88e0a797d2af2cfdbda3939150299710.png";